import * as React from 'react'
import { t } from 'i18next'
import { withRouter, RouteComponentProps } from 'react-router'

type SearchBarProps = {
  show: boolean
  hide?: () => void
  searchValue: string
  updateSearchValue: (newValue: string) => void
}

type SearchFormProps = RouteComponentProps &
  Pick<SearchBarProps, 'hide' | 'searchValue' | 'updateSearchValue'> & { label?: string }

export const SearchForm = withRouter((props: SearchFormProps) => (
  <form
    className='search-form'
    onSubmit={e => {
      e.preventDefault()
      props.history.push(`${window.wp.language != 'en' ? `/${window.wp.language}/zoeken` : '/search' }/${props.searchValue}`)
    }}
  >
    <label className='search-form__label typo--l'>
      {props.label}
      <input
        className='search-form__input typo--xs'
        //ref={e => e && e.focus()}
        placeholder={t('searchbar.placeholder')}
        type='text'
        value={props.searchValue}
        onChange={e => props.updateSearchValue(e.target.value)}
      />
      <button className='search-form__icon' type="submit">
        <svg className='icon icon--arrow-right' width='26px' height='16px'>
          <use xlinkHref='#arrow-right' />
        </svg>
      </button>
    </label>
  </form>
))

export const SearchBar = (props: SearchBarProps) => {
  return (
    <>
      <div className={`searchbar ${props.show ? 'searchbar--show' : ''}`}>
        <div className='searchbar__inner container--xl grid--block'>
          <button className='searchbar__close' onClick={props.hide}>
            <span className='sr-text'>{t('general.close')}</span>
            <span className='line line--first' />
            <span className='line line--second' />
          </button>

          <SearchForm
            searchValue={props.searchValue}
            updateSearchValue={props.updateSearchValue}
            label={t('searchbar.label')}
          />
        </div>
      </div>
      <div
        className={`searchbar__overlay ${props.show ? 'searchbar__overlay--show' : ''}`}
        onClick={props.hide}
      />
    </>
  )
}
